// src/utils/securityUtils.js
export const generateSignature = async (apiSecret, method, path, timestamp) => {
  const payload = timestamp + method + path;

  // Usando Web Crypto API para generar HMAC-SHA256
  const encoder = new TextEncoder();
  const key = encoder.encode(apiSecret);
  const message = encoder.encode(payload);

  try {
    const cryptoKey = await crypto.subtle.importKey(
      'raw',
      key,
      { name: 'HMAC', hash: 'SHA-256' },
      false,
      ['sign']
    );

    const signature = await crypto.subtle.sign('HMAC', cryptoKey, message);

    // Convertir ArrayBuffer a hex string
    return Array.from(new Uint8Array(signature))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  } catch (error) {
    console.error('Error generando firma:', error);
    throw new Error('No se pudo generar la firma de seguridad');
  }
};

export const getTimestamp = () => {
  return Math.floor(Date.now() / 1000).toString();
};

export const createAuthHeaders = async (method, path) => {
  const timestamp = getTimestamp();
  const apiKey = process.env.REACT_APP_API_KEY;
  const apiSecret = process.env.REACT_APP_API_SECRET;

  if (!apiKey || !apiSecret) {
    throw new Error('Faltan credenciales de API en variables de entorno');
  }

  const signature = await generateSignature(apiSecret, method, path, timestamp);

  return {
    'X-API-Key': apiKey,
    'X-Timestamp': timestamp,
    'X-Signature': signature,
    'Content-Type': 'application/json',
  };
};
